import React from "react";
import { getImageUrl, getProfileImageUrl } from "helpers/Image.helper";
import { getStudentNickname, getFlagByCountryCode, getStudentName } from "helpers/String.helper";
import LoadingComponent from "commons/loading/Loading.component";
import StudentImageTimeline from "./StudentImageTimeline";
import DiaryTimeline from "./DiaryTimeline";

const WELCOME_MESSAGE_LIST = [
  "최고의 캐스팅 매니저가 될 수 있도록 도와드릴게요!",
  "캐스팅 매니저님의 관심이 지망생들의 꿈을 이뤄줄 거예요!",
  "오늘도 즐거운 캐스팅 될 수 있게 도와드릴게요!",
];

const IndexComponent = (props: any) => {
  const { isInit, recentlySignupStudentList, updatedFavoriteList,
    onClickStudent, favoriteCount, todayViewCount, chatRequestCount, chattingCount, userStudentImageList,
    handleClickFavoriteCount, handleClickTodayViewCount, handleClickChatRequestCount, handleClickChattingCount,
    handleStudentInfoPopup, isOnLoadingPhotos, hasMore, handleLoadMorePhotos, handleStudentImageSlidePopup } = props;

  return (
    <main className="bg-gray-50 min-h-screen">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 pt-6">
        {/* <h2 className="text-3xl font-bold text-gray-900 mb-8">대시보드</h2>
        <p className="text-sm text-gray-500 mb-8">
          {WELCOME_MESSAGE_LIST[Math.floor(Math.random() * WELCOME_MESSAGE_LIST.length)]}
        </p> */}
        {!isInit &&
          <LoadingComponent />
        }
        {isInit &&
          <div className="space-y-6">
            {/* 신규회원 목록 섹션 */}
            {recentlySignupStudentList.length > 0 &&
              <section className="mb-4 sm:mb-6">
                <h2 className="text-lg sm:text-xl font-bold text-gray-900 mb-4">신규 지망생</h2>
                <div className="flex md:grid overflow-x-auto scrollbar-hide md:grid-cols-4 lg:grid-cols-6 gap-4">
                  {recentlySignupStudentList.map((item: any, index: number) => (
                    <div key={index} className="flex-shrink-0 w-auto text-center px-2" onClick={() => handleStudentInfoPopup(item.id)}>
                      <div className="relative inline-block mb-2">
                        <div className="w-16 h-16 sm:w-20 sm:h-20 rounded-full overflow-hidden mx-auto">
                          <img
                            src={getProfileImageUrl(item.profileImageInfo, 200)}
                            alt={getStudentNickname(item)}
                            className="w-full h-full object-cover"
                          />
                        </div>
                        <span className="absolute -bottom-3 left-1/2 transform -translate-x-1/2 text-xl sm:text-2xl">
                          {getFlagByCountryCode(item.countryInfo?.code)}
                        </span>
                      </div>
                      <p className="font-medium text-sm">{getStudentName(item)}</p>
                    </div>
                  ))}
                </div>
              </section>
            }
            <DiaryTimeline />
          </div>
        }
      </div>
    </main>
  );
};

export default IndexComponent;